export default __webpack_public_path__ + "static/media/cutout-shapes.be681055.jpg";